<div id="content" class="allcp-form map-content" ng-controller="OrderController" ng-init="init()">
<div ng-include="'modules/company/menus/order_menu.html'"></div>
<div class="row">
    <div id="map" ng-click="clearMap()"></div>
    <div class="tab">
        <ul>
            <li ng-class="tab == 0 ? 'active' : '' " ng-click="tab = 0"><a href="#">İşler</a></li>
            <li ng-class="tab == 1 ? 'active' : '' " ng-click="tab = 1"><a href="#">Harita</a></li>
            <li ng-class="tab == 2 ? 'active' : '' " ng-click="tab = 2"><a href="#">Çalışanlar</a></li>
        </ul>
    </div>
    <div ng-include="'modules/company/dashboard/partials/left_sidebar.html'"></div>
    <div ng-include="'modules/company/dashboard/partials/right_sidebar.html'"></div>
    <div ng-include="'modules/company/dashboard/partials/first_look.html'"></div>
    <div ng-include="'modules/company/dashboard/partials/updates.html'"></div>

    <!-- Assign Worker -->
    <div class="modal right fade" id="assignMultiOrder" tabindex="-1" role="dialog" aria-labelledby="assignMultiOrderLabel">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <div class="modal-title">
                        <h4 id="newChatLabel">Assign Order(s)</h4>
                        <!-- <span>{{ selectedWork.unique }}</span> -->
                    </div>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <i class="icon-close-circle"></i>
                    </button>
                </div>
                <div class="modal-body order-detail-page">
                    <div class="modal-body-container">
                        <div class="tab-content">
                            <div class="tab-pane active">
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="form-group floating">
                                            <!-- <select 
                                                ng-model="selectedWork.worker_id" 
                                                class="form-control"
                                                ng-options="worker.id as worker.full_name for worker in data.workers">
                                                <option value="">Select Driver</option>
                                            </select> -->

                                            <select class="selectpicker" 
                                                title="By Driver"
                                                data-live-search="true"
                                                key="{{modalKey}}"
                                                data-selected-text-format="count" 
                                                data-language="tr_TR"
                                                ng-model="assigned_worker_id"
                                                ng-keyup="$event.keyCode == 13 && refreshData()"
                                                data-style="btn-primary">
                                                <option 
                                                    ng-repeat="member in assignWorkers | orderBy:['status']"
                                                    ng-if="!member.user.status" 
                                                    data-select-watcher 
                                                    data-last="{{$last}}" 
                                                    class="worker-{{member.vehicle}}"
                                                    value="{{member.id}}">
                                                    {{member.full_name}}
                                                </option>
                                            </select>
                                        </div>
                                        <div class="form-group floating">
                                            <button type="submit" 
                                                ng-click="assignMultiOrderDriver()" 
                                                class="hod-button blue">
                                                <span>Assign</span>
                                            </button>
                                            <button type="button" 
                                                class="hod-button blue" 
                                                data-dismiss="modal">
                                                Cancel
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>


</div>
</div>
<style>
    html, body {
        height:100% !important;
        overflow: hidden;
    }
</style>
<script>
    $(document).ready(function(){
    var height = $(window).height() - 116;
    $('.map-content').css('height',height);
        $(window).resize(function(){
        var height = $(window).height() - 116;
        $('.map-content').css('height',height);
        });
    });
</script>